import {
  CLEAR_REPORT_DATA_ERROR,
  GET_REPORT_DATA,
  GET_REPORT_DATA_ERROR,
  GET_REPORT_DATA_SUCCESS,
  GET_REPORT_PROGRESS_SUCCESS,
  INVALIDATE_REPORT_DATA_CACHE,
  INVALIDATE_REPORT_DATA_CACHE_ERROR,
  INVALIDATE_REPORT_DATA_CACHE_SUCCESS,
  REPORT_DATA_WAITING_FOR_CALCULATION,
} from './constants'

export const getReportData = ({
  companyCode,
  customerCode,
  enableCaching,
  reportId,
  setLoading = true,
}) => ({
  type: GET_REPORT_DATA,
  companyCode,
  customerCode,
  enableCaching,
  reportId,
  setLoading,
})
// handleError merges the parsed error, errorType and additionalData into one object and calls this
// with that single object, so the company the read was for is read back off it. The reducer needs
// it to tell a late answer from the one the view is waiting for - see its `answersAStaleCompany`.
export const getReportDataError = (error) => {
  return {
    type: GET_REPORT_DATA_ERROR,
    companyCode: error?.companyCode,
    error,
  }
}
export const getReportDataSuccess = ({
  report,
  reportId,
  companyCode,
  calculated,
  exchangeRates,
  calculationInProgressFor,
}) => ({
  type: GET_REPORT_DATA_SUCCESS,
  report,
  calculated,
  exchangeRates,
  // Display names of companies an actuals calculation is still writing, as of the moment this
  // cached report was served. Always an array - empty for a report that was freshly built.
  calculationInProgressFor: calculationInProgressFor ?? [],
  reportId,
  companyCode,
})

export const reportDataWaitingForCalculation = ({
  companyCode,
  reportId,
  companies,
}) => ({
  type: REPORT_DATA_WAITING_FOR_CALCULATION,
  companyCode,
  reportId,
  // Companies whose actuals are being calculated, as named by the API.
  companies: companies || [],
})
export const getReportProgressSuccess = ({
  companyCode,
  progress,
  reportId,
}) => ({
  type: GET_REPORT_PROGRESS_SUCCESS,
  companyCode,
  progress,
  reportId,
})
export const invalidateReportDataCache = ({ reportId }) => ({
  type: INVALIDATE_REPORT_DATA_CACHE,
  reportId,
})
export const invalidateReportDataCacheError = (error) => ({
  type: INVALIDATE_REPORT_DATA_CACHE_ERROR,
  error,
})
export const invalidateReportDataCacheSuccess = ({ reportId }) => ({
  type: INVALIDATE_REPORT_DATA_CACHE_SUCCESS,
  reportId,
})

export const clearReportDataError = ({ reportId }) => ({
  type: CLEAR_REPORT_DATA_ERROR,
  reportId,
})
